<template>
  <div class="global-loader d-inline-block p-relative">
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<style lang="scss">
  .global-loader {
    width: 70px;
    height: auto;

    &.white div {
      background-color: rgb(var(--white));
    }

    div {
      position: absolute;
      top: -4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--primary);
      animation-timing-function: cubic-bezier(0, 1, 1, 0);

      &:nth-child(1) {
        left: 8px;
        animation: global-loader-1 0.6s infinite;
      }
      &:nth-child(2) {
        left: 8px;
        animation: global-loader-2 0.6s infinite;
      }
      &:nth-child(3) {
        left: 32px;
        animation: global-loader-2 0.6s infinite;
      }
      &:nth-child(4) {
        left: 56px;
        animation: global-loader-3 0.6s infinite;
      }
    }
  }
</style>
